import { PublicKey } from "@solana/web3.js";
import { programs } from "@metaplex/js";

export default function findMasterEditionAddress(mint: PublicKey) {
  return programs.metadata.MasterEdition.getPDA(mint);
}
